import { Wifi, Tv, Wind, Sparkles, Utensils, Car, ShieldCheck, Clock } from 'lucide-react';

const amenities = [
  {
    icon: Wind,
    title: 'Air Conditioning',
    description: 'All rooms equipped with AC for your comfort',
  },
  {
    icon: Tv,
    title: 'Television',
    description: 'Flat-screen TVs with cable channels',
  },
  {
    icon: Wifi,
    title: 'Free Wi-Fi',
    description: 'High-speed internet throughout the property',
  },
  {
    icon: Sparkles,
    title: 'Laundry Service',
    description: 'Professional laundry services available',
  },
  {
    icon: ShieldCheck,
    title: 'Hygiene Protocols',
    description: 'Enhanced cleaning and sanitization standards',
  },
  {
    icon: Car,
    title: 'Easy Access',
    description: 'Just 5 km from Vizag Airport',
  },
  {
    icon: Clock,
    title: '24/7 Service',
    description: 'Round-the-clock front desk assistance',
  },
  {
    icon: Utensils,
    title: 'Nearby Dining',
    description: 'Close to restaurants and local dining options',
  },
];

export function Amenities() {
  return (
    <section id="amenities" className="py-16 sm:py-24 bg-gray-50">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="mb-4">Hotel Amenities</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Enjoy a comfortable stay with our range of modern amenities designed to make your visit memorable.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {amenities.map((amenity, index) => {
            const Icon = amenity.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-indigo-600" />
                </div>
                <h3 className="mb-2">{amenity.title}</h3>
                <p className="text-gray-600 text-sm">{amenity.description}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 bg-white rounded-xl shadow-md p-8">
          <h3 className="mb-4 text-center">Our Commitment to Hygiene</h3>
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-indigo-600 mb-2">✓</div>
              <p className="text-gray-700">Daily sanitization of all rooms and common areas</p>
            </div>
            <div>
              <div className="text-indigo-600 mb-2">✓</div>
              <p className="text-gray-700">Fresh linen and towels for every guest</p>
            </div>
            <div>
              <div className="text-indigo-600 mb-2">✓</div>
              <p className="text-gray-700">Regular health checks for all staff members</p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}
